


































import Vue from "vue";
import { mapState } from "vuex";
import { formatSize } from "@/utils/util";
import staticIcons from "@/utils/static-icons";
import { parseTime } from "@/utils/filters";

export default Vue.extend({
  name: 'file-list-item',
  filters: {
    parseTime(time: string) {
      return parseTime(time, "{y}-{m}-{d} {h}:{i}");
    },
    displayIcon(info: any) {
      return info.thumbnail_link || info.icon_link || staticIcons.other;
    }
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    index: Number,
    selected: Array
  },
  data() {
    return {
      checked: this.selected.includes(this.info.id),
      clicked: false,
      videoTypes: [
        "rmvb",
        "3gp",
        "mkv",
        "mp4",
        "flv",
        "avi",
        "wmv",
        "rm",
        "mpg",
        "ts",
        "mov",
        "xv",
        "asf",
        "f4v",
        "m4v",
        "mpeg",
        "rmv",
        "ram"
      ],
      audioTypes: [
        "mp3",
        "wma",
        "ape",
        "aac",
        "acc",
        "wav",
        "pcm",
        "ogg",
        "mid",
        "flac",
        "m4a"
      ]
    };
  },
  computed: {
    ...mapState("drive", ["curFilter"]),
    isTrash() {
      return this.curFilter === "trash";
    },
    fixedFolder() {
      return this.info.folder_type !== 'NORMAL'
    }
  },
  watch: {
    selected(val) {
      this.checked = val.includes(this.info.id);
    }
  },
  methods: {
    formatSize,
    getType() {
      return this.info.kind.indexOf("folder") !== -1 ? "folder" : "file";
    },
    handleItemClick() {
      this.$emit("select-click", { info: this.info, checked: true });
    },
    handleSelect(val: any) {
      this.$emit("select-change", { info: this.info, checked: val });
    },
    handleNameClick() {
      if (!this.clicked) {
        this.clicked = true;
        this.$emit("content-click", { info: this.info });
      }

      setTimeout(() => {
        this.clicked = false;
      }, 300);
    },
    handleDoubleClick() {
      if (!this.clicked) {
        this.$emit("content-click", { info: this.info });
      }
    }
  }
});
